module.exports = __webpack_public_path__ + "media/images/Candle-Holder-Empty-Test2-e866581773e3511d253c7ed074ea7c74.png";